module.exports = __webpack_public_path__ + "img/goods_icon.599ff238.png";